import CalculsStatistiquesController from './calculs.statistiques.controller';

export default {
    template: require('./calculs.statistiques.tpl.html'),
    controller: CalculsStatistiquesController
};
